function ContactUs({ goBack }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg,#000000,#1a1a1a,#ffd600)",
        padding: "30px"
      }}
    >
      <button
        onClick={goBack}
        style={{
          backgroundColor: "#ffd600",
          color: "black",
          border: "none",
          padding: "12px 20px",
          borderRadius: "10px",
          cursor: "pointer",
          fontWeight: "bold"
        }}
      >
        ⬅ Back
      </button>

      <div
        style={{
          maxWidth: "800px",
          margin: "40px auto",
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "25px",
          boxShadow:
            "0 10px 25px rgba(0,0,0,0.3)"
        }}
      >
        <h1
          style={{
            textAlign: "center",
            color: "#000",
            marginBottom: "25px"
          }}
        >
          Contact MNHouseFinder
        </h1>

        <p
          style={{
            textAlign: "center",
            color: "#555",
            fontSize: "18px",
            marginBottom: "35px",
            lineHeight: "1.8"
          }}
        >
          We'd love to hear from you. Reach out to us using
          the information below.
        </p>

        <div
          style={{
            backgroundColor: "#f8f8f8",
            padding: "30px",
            borderRadius: "15px",
            lineHeight: "2"
          }}
        >
          <h2
            style={{
              color: "#000",
              marginBottom: "10px",
              marginTop: "0"
            }}
          >
            Office Location:
          </h2>

          <p style={{ marginBottom: "20px" }}>
            📍 Sunrise House, Kithimani
          </p>

          <h2
            style={{
              color: "#000",
              marginBottom: "10px",
              marginTop: "25px"
            }}
          >
            Telephone
          </h2>

          <p style={{ marginBottom: "5px" }}>
            📞 0745 746 190
          </p>

          <p style={{ marginBottom: "20px" }}>
            📞 0798 061 862
          </p>

          <h2
            style={{
              color: "#000",
              marginBottom: "10px",
              marginTop: "25px"
            }}
          >
            Email
          </h2>

          <p>
            📧 supportmnhousefinder@gmail.com
          </p>
        </div>

        <div
          style={{
            marginTop: "35px",
            textAlign: "center",
            color: "#666",
            lineHeight: "1.8"
          }}
        >
          <p style={{ marginBottom: "10px" }}>
            Thank you for choosing MNHouseFinder.
          </p>

          <p style={{ margin: 0 }}>
            We are committed to making house hunting and property advertising hassle-free.
          </p>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;